module.exports = __webpack_public_path__ + "static/media/8OLA15.e5793a33.jpg";